export default __webpack_public_path__ + "43e0442ec46c948469abfea6a6ac8810.svg";